// extracted by css-extract-rspack-plugin
export default {"detailCard":"detailCard-ok7qAM","figureBox":"figureBox-s86f81","figure":"figure-KkBf1F","bullet":"bullet-zPdjf3","backButton":"backButton-VhzVpp","modalCta":"modalCta-pUesYy"};